import { render, staticRenderFns } from "./PredictorSliderWrap.vue?vue&type=template&id=35ec1106"
import script from "./PredictorSliderWrap.vue?vue&type=script&lang=js"
export * from "./PredictorSliderWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports